import { createFileRoute } from '@tanstack/react-router';
import { type AggregateBreadcrumb, buildBreadcrumb } from '@interxfi/app-components/components/router-breadcrumbs/router-breadcrumbs';

export const Route = createFileRoute('/_app/_clearing-core/sweep/plan/_plan')({
  loader: () =>
    ({
      breadcrumb: buildBreadcrumb({
        id: 'sweep-plans-list',
        label: 'Sweeps',
        to: '/sweep/plan',
      }),
    }) satisfies AggregateBreadcrumb,
});
